import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Austin.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Get Noticed & Grow with Disruptive App Development Company in
              Austin
            </h2>
            <p>
              Choose the best mobile app development company in Austin for
              disruptive solutions that get you noticed across app marketplaces
              and outperform the competition. We excel in gamification
              strategies and leverage user-driven advancements for rapid
              development.
            </p>
            <p>
              Our agile methodologies ensure zero downtime and continuous
              advancements to keep your app performing. With a focus on
              user-centric design and useful-only features, we create apps that
              captivate audiences and bring automation. Partner with us to
              access the technologies and expertise necessary to win.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Develop My App
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
